<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-gavel"></i></div>
      <div>
        Gestion des sanctions
        <div class="page-title-subheading">Gestion des sanctions</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
   <div class="row">
    <div class="col-lg-12">
        <div class="card">
          
            <div class="card-body">
                  <div class="d-flex justify-content-between mb-5">
                    <div class="me-2">
                        <button *ngIf="buttonsPermission?.add" type="button" class="btn btn-danger btn-sm" (click)="add(addContent)">
                            <i class="fa-solid fa-plus me-2" aria-hidden="true"></i>Nouvelle sanction
                            </button>
                    </div>
                    <div class=" " *ngIf="buttonsPermission">
                        <button *ngIf="selected_data && buttonsPermission.show"  (click)="show(showContent)" type="button" class="btn btn-outline-primary btn-sm btn-label waves-effect waves-light me-3">
                             <span>Consulter</span></button>
                        <button *ngIf="selected_data && buttonsPermission.edit" (click)="edit(editContent)" type="button"  class="btn btn-outline-warning btn-sm btn-label waves-effect waves-light me-3">
                           Editer</button>
                        <button *ngIf="selected_data && buttonsPermission.delete" (click)="delete()" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
                             Supprimer</button>
                             <button *ngIf="selected_data && is_active!=null && !is_active" (click)="setStatus(1)" type="button" class="btn btn-outline-success btn-sm btn-label waves-effect waves-light me-3">
                                Activer</button>
                               <button  *ngIf="selected_data && is_active!=null && is_active" (click)="setStatus(0)" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
                                Désactiver</button>
                    </div>

                    <div class="form-group ms-auto">
                        <label for=""> <strong>Rechercher:</strong> </label>
                        <input placeholder="Rechercher..." class="form-control form-control-sm" type="text" name="search_text" [(ngModel)]="search_text">
                    </div>
                </div>

                        <p>{{data!.length}} élément(s)</p>
                        <div class="table-responsive">
                        <table class="table" >
                            <thead class="">
                                <tr>
                                    <th style="width: 10px;">#</th>
                                    <th>Elève</th>
                                    <th>Faute</th>
                                    <th>Sanction</th>
                                    <th>Periode</th>
                                    <th>Date enreg.</th>
                                    <!-- <th>Statut</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr (click)="checked(d)" [class.table-active]="selected_data?.id === d.id" style="cursor: pointer;" *ngFor="let d of data | sampleSearch:search_text:'rooms' | paginate: {
                                id:'ngxP1',
                                itemsPerPage: pg.pageSize,
                                currentPage: pg.p,
                                totalItems: pg.total } ">
                                    <td>
                                        <div class="form-check mb-2">
                                            <input (click)="checked(d)" class="form-check-input" type="radio" [checked]="selected_data?.id === d.id" name="flexRadioDefault">
                                        
                                        </div>
                                    </td>
                                    <td>{{d.sac?.student?.lastname}} {{d.sac?.student?.firstname}}</td>
                                    <td>{{d.fault}}</td>
                                    <td>{{d.sanction}}</td>
                                    <td>{{d.period?.name}}</td>
                                    <!-- <td>
                                        <span *ngIf="d.is_active" class="badge bg-success">Actif</span>
                                        <span *ngIf="!d.is_active" class="badge bg-danger">Bloqué</span>

                                    </td> -->
                                    <td>{{d.created_at | date:"dd-MM-yyyy"}}</td>

                                </tr>
                            
                            </tbody>
                        </table>
                        </div>
                        <pagination-controls 
                        id="ngxP1"
                        (pageChange)="getPage($event)"
                      [maxSize]="9"
                      [directionLinks]="true"
                      [autoHide]="true"
                      [responsive]="true"
                      [previousLabel]="'Précédent'"
                      [nextLabel]="'Suivant'"
                      [screenReaderPaginationLabel]="'Pagination'"
                      [screenReaderPageLabel]="'page'"
                      [screenReaderCurrentLabel]="'Vous êtes sur la page'">
                     </pagination-controls>

            </div><!-- end card -->
        </div>
        <!-- end col -->
    </div>
    <!-- end col -->
</div>


<ng-template #addContent let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Enregistrer une sanction</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
            <div class="form-group ">
                <label for="">Choisir la classe</label>
                <ng-select  (change)="loadSacs($event)" >
                    <ng-option selected disabled></ng-option>
                    <ng-option *ngFor="let classroom of classrooms" [value]="classroom?.id">{{classroom?.name}}</ng-option>
                </ng-select>
            </div>
            <div class="form-group ">
                <label for="">Choisir l'apprenant</label>
                <ng-select name="sac_id" ngModel >
                    <ng-option selected disabled></ng-option>
                    <ng-option *ngFor="let sac of sacs" [value]="sac.if">{{sac?.student?.lastname}} {{sac?.student?.firstname}}</ng-option>
                </ng-select>
            </div>
            <div class="form-group ">
                <label for="">Choisir la période</label>
                <ng-select name="period_id"  ngModel >
                    <ng-option selected disabled></ng-option>
                    <ng-option *ngFor="let period of periods" [value]="period?.id">{{period?.name}}</ng-option>
                </ng-select>
            </div>
            
            <div class=" form-group col-12 mb-3">
                <label for="">Faute <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="fault" class="form-control" ngModel>
            </div>
        
            <div class=" form-group col-12 mb-3">
                <label for="">Sanction <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="sanction" class="form-control" ngModel>
            </div>
        
         
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>

  <ng-template #editContent let-c="close" let-d="dismiss">
    <form #editForm="ngForm" (ngSubmit)="update(editForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Modifier une sanction</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
            <div class="form-group ">
                <label for="">Choisir la classe</label>
                <ng-select (change)="loadSacs($event)" >
                    <ng-option selected disabled></ng-option>
                    <ng-option *ngFor="let classroom of classrooms" [value]="classroom?.id">{{classroom?.name}}</ng-option>
                </ng-select>
            </div>
            <div class="form-group ">
                <label for="">Choisir l'apprenant</label>
                <ng-select name="sac_id" [(ngModel)]="selected_data.sac_id">
                    <ng-option selected disabled></ng-option>
                    <ng-option *ngFor="let sac of sacs" [value]="sac?.id">{{sac?.student?.lastname}} {{sac?.student?.firstname}}</ng-option>
                </ng-select>
            </div>
            <div class="form-group ">
                <label for="">Choisir la période</label>
                <ng-select name="period_id" [(ngModel)]="selected_data.period_id" >
                    <ng-option selected disabled></ng-option>
                    <ng-option *ngFor="let period of periods" [value]="period?.id">{{period?.name}}</ng-option>
                </ng-select>
            </div>
            
            <div class=" form-group col-12 mb-3">
                <label for="">Faute <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="fault" class="form-control" ngModel>
            </div>
        
            <div class=" form-group col-12 mb-3">
                <label for="">Sanction <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="sanction" class="form-control" ngModel>
            </div>
        
         
        </div>
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="editForm.invalid" >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>

  <ng-template #showContent let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Détails des informations</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
      </div>

      <div class="modal-body">
        <div class="table-responsive table-card">
            <table class="table table-borderless align-middle mb-0">
                <tbody>
                 
                </tbody>
            </table>
        </div>
      </div>
</ng-template>
